import { render } from "./GenericalView.vue?vue&type=template&id=058d6590"
const script = {}

import exportComponent from "/home/gustavo/Documents/frontend-ivv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__